import { LocaleConfig } from 'lib/plugins/WangsVue';

const locale: LocaleConfig = {
  global: {},
  components: {
    FieldWrapper: {
      labelOptional: '(opsional)',
    },

    ButtonBulkAction: {
      currentSelectionMessage: '{length} {naming} dipilih',
      allRecordSelected: 'Semua data terpilih',
      selectAllRecords: 'Pilih semua ({totalRecords} data)',
    },

    DataTable: {
      downloadingMessage: 'Mengunduh data',
      falseText: 'Tidak',
      trueText: 'Ya',
      paginationReportFound: 'Menampilkan {first} - {last} dari {totalRecords}',
      paginationReportNotFound: 'Tidak ditemukan data',
    },

    ButtonDownload: {
      downloadingMessage: 'Mengunduh data',
      falseText: 'Tidak',
      trueText: 'Ya',
    },

    ImageCompressor: {
      cropperCtrlScrollInfo:
        'Gunakan Ctrl + Scroll untuk perbesar atau perkecil gambar',
      cropperTwoFingerInfo:
        'Gunakan dua jari untuk untuk perbesar atau perkecil gambar',
      cropDialogHeader: 'Sesuaikan gambar',
      imageTypeRequirement: 'Maks. 1 MB',
      maxSizeRequirement: 'Hanya mendukung format gambar',
      cancelCropLabel: 'Batal',
      applyCropLabel: 'Terapkan',
      changeImageLabel: 'Ganti Gambar',
    },

    Toast: {
      networkErrorMessage: ' Silahkan cek kembali koneksi Anda.',
    },
  },
};

export default locale;
